import { render, staticRenderFns } from "./PlaquenilWeightCalc.vue?vue&type=template&id=8abae152&scoped=true&"
import script from "./PlaquenilWeightCalc.vue?vue&type=script&lang=js&"
export * from "./PlaquenilWeightCalc.vue?vue&type=script&lang=js&"
import style0 from "./PlaquenilWeightCalc.vue?vue&type=style&index=0&id=8abae152&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abae152",
  null
  
)

export default component.exports